import types from '../mutation-types';
import Vue from 'vue';
import templatesAPI from '../../api/templates';

export const state = {
  records: [],
  tab: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isEditing: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getTab(_state) {
    return _state.tab;
  },
  getList(_state){
    return _state.records;
  }
};

export const actions = {
  async deleteTemplate({ commit }, { name, providerConfig }) {
    commit(types.SET_TEMPLATES_UI_FLAG, { isDeleting: true });
    try {
      await templatesAPI.deleteTemplate(name, providerConfig);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_TEMPLATES_UI_FLAG, { isDeleting: false });
    }
  },
    async create({ commit }, payload) {
        console.log('payload modules', payload);
        commit(types.SET_TEMPLATES_UI_FLAG, { isCreating: true });
        try {
            await templatesAPI.create(payload);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_TEMPLATES_UI_FLAG, { isCreating: false });
        }
    },
    async getTemplates({ commit }) {
        commit(types.SET_TEMPLATES_UI_FLAG, { isFetching: true });
        try {
            const response = await templatesAPI.getTemplates();
            commit(types.SET_TEMPLATES, response.data);
        } catch (error) {
            throw new Error(error);
        }
    },
      
};

export const mutations = {
  [types.SET_TEMPLATES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
